// extracted by mini-css-extract-plugin
export default {"loaderEditProfile":"editProfile_loaderEditProfile__gxJ83","rotation":"editProfile_rotation__qc3Sl"};